module.exports = __webpack_public_path__ + "img/unfinish.848301d5.svg";